module.exports = __webpack_public_path__ + "static/media/Carat.aefbb672.png";